
module.config(function($stateProvider) {

    $stateProvider.state('student.education', {
        url: "/education",
        templateUrl: 'students/educationProfile/view',
        controller: 'EducationProfileController',
        resolve: {
            educationProfile: function(student, ModelService) {
                return ModelService.get('education_profile', student.id);
            },
            brandeisData: function(student, ModelService) {
                if (student.is_brandeis) {
                    return ModelService.get('brandeis_data', student.id);
                }
                return false;
            },
            educationTests: function(student, ModelService) {
                return ModelService.getRelation(
                    'education_profile', student.id, 'tests');
            },
        },
    });
});
